import styled from "styled-components";

const FilterProductPrice = styled.ul`
  --svg-size: 20px;

  .filter-product-price__header {
    @media (max-width: 859px) {
      display: none;
    }
    @media (min-width: 860px) {
      display: flex;
      align-items: baseline;
    }
  }

  .filter-product-price__heading {
    @media (max-width: 859px) {
      display: none;
    }
    @media (min-width: 860px) {
      color: ${({theme}) => theme.colors.brandDark};
    }
  }

  .submit_price_range {
    display: flex;
    align-items: center;
  }

  .filter-product-price__button {
    margin-left: 10px;
    padding: 8px;
    border: 1px solid ${({theme}) => theme.colors.gray3};
    color: ${({theme}) => theme.colors.gray3};
    line-height: 1;
    outline: none;
    transition: var(--button-transition);

    &:hover,
    &:focus {
      border-color: ${({theme}) => theme.colors.brand};
      color: ${({theme}) => theme.colors.brand};
    }

    &:disabled {
      background-color: ${({theme}) => theme.colors.disabled};
      border-color: ${({theme}) => theme.colors.disabled};
      cursor: not-allowed;

      &:hover,
      &:focus {
        color: ${({theme}) => theme.colors.gray3};
      }
    }
  }
  
  .filter-product-type__clear {
    margin-left: auto;
    padding: 4px 0;
    color: ${({theme}) => theme.colors.gray3};
    outline: none;

    &:hover,
    &:focus {
      color: ${({theme}) => theme.colors.brand};
      box-shadow: inset 0px -2px 0px 0px ${({theme}) => theme.colors.brand};
    }

    &.selected {
      color: ${({theme}) => theme.colors.brand};

    }
  }

  .filter-product-price__type {
    width: 100%;
    display: inline-flex;
    align-content: center;
    flex-direction: column;

    @media (max-width: 859px) {
      &:not(:first-of-type) {
        margin-top: .75rem;
      }
    }
    @media (min-width: 860px) {
      &:not(:first-child) {
        margin-top: .75rem;
      }
    }
  }

  .filter-product-price__radio {
    padding-top: .125rem;
    padding-bottom: .125rem;
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    transition: var(--button-transition);
    width: 126px;

    &.is-checked {
      background-color: ${({theme}) => theme.colors.highlight};

      .filter-product-type__radio__svg-left,
      .filter-product-type__radio__svg-right {
        opacity: 1
      }
    }

    &:hover,
    &:focus {
      background-color: ${({theme}) => theme.colors.highlight};

      .filter-product-type__radio__svg-left,
      .filter-product-type__radio__svg-right {
        opacity: 1
      }
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;

      &:checked ~ .filter-product-price__radio__custom {
        background-color: ${({theme}) => theme.colors.brandDark};
        border-color: ${({theme}) => theme.colors.brandDark};
      }
    }
  }

  .filter-product-type__radio__svg-right,
  .filter-product-type__radio__svg-left {
    display: block;
    opacity: 0;
    position: absolute;
    top: 0;
    width: var(--svg-size);
    height: var(--svg-size);
    fill: ${({theme}) => theme.colors.highlight};
    transition: var(--button-transition);
  }

  .filter-product-type__radio__svg-left {
    left: calc(var(--svg-size) * -1);
  }

  .filter-product-type__radio__svg-right {
    right: calc(var(--svg-size) * -1);
  }

  .filter-product-price__radio__custom {
    position: relative;
    height: 16px;
    width: 16px;
    background-color: transparent;
    border: 1px solid ${({theme}) => theme.colors.gray2};
    border-radius: 50%;

    &::after {
      position: absolute;
      content: "";
      border-radius: 0;
    }
  }

  .filter-product-price__radio__copy {
    margin-left: 8px;
    color: ${({theme}) => theme.colors.brandDark};
  }

  .filter-product-price__inputs {
    margin-top: 1rem;
    display: flex;
    align-items: center;

    @media (max-width: 859px) {
      max-width: 208px
    }
    @media (min-width: 860px) {
    }
  }

  .filter-product-price__input {
    width: 40%;
    display: inline-flex;
    align-items: center;

    input {
      padding: 8px 0 8px 12px;
      width: 100%;
      border: 1px solid ${({theme}) => theme.colors.gray2};
      outline: none;
      transition: var(--button-transition);

      &:hover,
      &:focus {
        border-color: ${({theme}) => theme.colors.brand};
      }
    }
  }

  .filter-product-price__copy {
    width: 20%;
    text-align: center;
  }
`;

export default FilterProductPrice;